import type { Control, FieldError } from "react-hook-form";
import type { FormInputData } from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormFieldController } from "../../../../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { FormSection } from "../../../../../../BuildingBlocks/Forms/FormSection/FormSection";
import { HelperText } from "../../../../../../BuildingBlocks/Forms/MantineFormFields/HelperText/HelperText";
import type { DeliveryFormFields } from "../../DeliveryForm.types";

interface PriceModelWithHeaderProps {
  control: Control<DeliveryFormFields>;
  error?: FieldError;
  data: FormInputData<DeliveryFormFields, "priceModel">;
  disabled?: boolean;
}
function PriceModelWithHeader({
  control,
  error,
  data,
  disabled
}: PriceModelWithHeaderProps) {
  return (
    <FormSection
      className="PriceModelWithHeader"
      label="Lieferkonditionen"
      mt="xl"
    >
      <FormFieldController
        control={control}
        data={
          { ...data, disabled } as FormInputData<
            DeliveryFormFields,
            "priceModel"
          >
        }
      />
      <HelperText error={error} />
    </FormSection>
  );
}

export { PriceModelWithHeader };
